import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {KindOfUpload} from './helpers/kind-of-upload.enum';
import {TreatmentChainService} from '../../../services/apiServices/business/treatment-chain.service';

import {CreateDepositService} from '../../../services/apiServices/business/create-deposit.service';
import {Subject} from 'rxjs';
import {KindOfAcceptedFilesService} from '../../../services/apiServices/business/kind-of-accepted-files.service';
import {FileStatus} from './helpers/file-status.enum';
import {Lre} from '../../../model/lre';
import {AuthenticationService} from '../../../services/apiServices/security/authentication.service';
import {EmailValidator} from '../../../model/email-validator';
import {Spool} from '../../../model/spool';
import {AddressLine} from '../../../model/address-line';
import * as moment from 'moment';
import {UserManagementService} from '../../../services/apiServices/business/user-management.service';
import {CommonService} from '../../../services/apiServices/business/common.service';

/**
 * Upload component, permit to handle various kind of uploads
 */
@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UploadComponent implements OnInit {

  /**
   * option choose by user: Permit to force choice on confirmation
   */
  @ViewChild('uploadChoice', {static: true}) private uploadChoice;

  /**
   * the binding of modal updateOrSaveVisible
   */
  @Input('visibleModal') public visibleModal: boolean;
  /**
   * the input kind of upload (Cf KindOfUploadEnum)
   */
  @Input('kindOfUpload') public kindOfUpload: string;
  /**
   * The event triggered by the modal itself
   */
  @Output() public modalDisplay: EventEmitter<boolean>;
  /**
   * Event triggered when the component should clear all selected files
   */
  @Output() public shouldClearFiles: Subject<any>;

  /**
   * lre object
   */
  public lreObject: Lre;
  public currentRecipientAddress: any;
  public currentSenderAddress: any;
  /**
   /**
   * List of selectable kind of upload
   */
  public options: SelectItem[];
  public btnClass: string;
  /**
   * option choose by user (for upload)
   */
  public selectedOption: string;

  /**
   * option label for upload as letter
   */
  private lreLabel: string;
  /**
   * option label for upload as letter
   */
  private letterLabel: string;
  /**
   * option label for upload as mailing
   */
  private mailingLabel: string;
  /**
   * option label for upload as spool
   */
  private spoolLabel: string;

  /**
   * the modal Title (not static)
   */
  public modalTitle: string;
  /**
   * label for upload as lre
   */
  private lreModalTitle: string;
  /**
   /**
   * label for upload as letter
   */
  private letterModalTitle: string;
  /**
   * label for upload as mailing
   */
  private mailingModalTitle: string;
  /**
   * label for upload as spool
   */
  private spoolModalTitle: string;
  /**
   * label for upload as spool
   */
  private notSetModalTitle: string;

  /**
   * handle various kind of Uploads, here only for template access
   */
  public KindOfUpload = KindOfUpload;

  /**
   * list of treatmentChains (for dropdown)
   */
  public treatmentChains: SelectItem[];
  public treatmentChainsLre: SelectItem[];
  public spools: Spool[];
  /**
   * current treatment chain
   */
  public selectedTreatmentChain: string;
  public selectedTreatmentChainLre: string;
  public selectedSpool: Spool;
  public delayedSend: boolean;
  public delayedSendDate: Date;
  public minDelayedSendDate: Date;
  public maxDelayedSendDate: Date;
  /**
   * list of selected files
   */
  public files: any[];

  /**
   * if the principal file selection is valid
   */
  public principalFileValidity: boolean;
  /**
   * if the annex file selection is valid
   */
  public annexeFileValidity: boolean;
  /**
   * if the data file selection is valid
   */
  public dataFileValidity: boolean;
  /**
   * if the spool file selection is valid
   */
  public spoolFileValidity: boolean;

  /**
   * Message display into confirmation box
   */
  public confirmationMessage: string;

  /**
   * title of toaster message on success
   */
  private successRequestTitle: string;

  /**
   * message of toaster message on success
   */
  private successRequestMessage: string;

  /**
   * title of toaster message on error
   */
  private errorRequestTitle: string;

  /**
   * message of toaster message on error
   */
  private errorRequestMessage: string;

  /**
   * Reference for template
   */
  public FileStatus = FileStatus;

  /**
   * Title for confirmation modal
   */
  private confirmationHeaderTitle: string;
  /**
   * Title for confirmation modal
   */
  public titleItems: SelectItem[];
  public authTypeItems: SelectItem[];
  public signerQualityItems: SelectItem[];
  public enableCreateSpool: boolean;
  public showCreateSpool: boolean;
  openRecipientAddress: boolean;
  openSenderAddress: boolean;
  showChainSelection: boolean;

  protected bDefaultTreatmentChainExist:boolean = false;

  /**
   * Instantiate variables
   * @param {TranslateService} translateService - handle component translations
   * @param {TreatmentChainService} treatmentChainService - handle treamtentChainList
   * @param {ConfirmationService} confirmationService - handle confirmation on context changes after adding files
   * @param {ChangeDetectorRef} changeDetectorRef - force change detection (avoid bug when switching context)
   * @param {CreateDepositService} createDepositService - handle upload files
   * @param commonService
   * @param {KindOfAcceptedFilesService} kindOfAcceptedFilesService - handle accepted files extensions and their status
   * @param {AuthenticationService} authService - handle accepted authentication for current users
   * @param userManagementService

   */
  constructor(private translateService: TranslateService, protected treatmentChainService: TreatmentChainService, private confirmationService: ConfirmationService,
              private changeDetectorRef: ChangeDetectorRef, private createDepositService: CreateDepositService, private commonService: CommonService,
              private kindOfAcceptedFilesService: KindOfAcceptedFilesService, private authService: AuthenticationService,
              private userManagementService: UserManagementService) {
    this.modalDisplay = new EventEmitter<boolean>();
    this.shouldClearFiles = new Subject();
    this.treatmentChains = [];
    this.treatmentChainsLre = [];
    this.spools = [];
    this.files = [];
    this.enableCreateSpool = false;
    this.showCreateSpool = false;
    this.openRecipientAddress = false;
    this.openSenderAddress = false;
  }

  /**
   * Init component by:
   * - Creating options
   * - Getting translations
   * - Getting treatmentChains
   * - Setting Modal Title
   * - Setting file acceptation
   */
  public ngOnInit(): void {
    this.showChainSelection = !(this.authService.getCurrentUser().physicalDeliveryOfficeName &&
      this.authService.getCurrentUser().physicalDeliveryOfficeName === 'NO_CHAIN_SELECTION');
    // noinspection DuplicatedCode

    let nowDate = moment();
    nowDate.add(3, 'days');
    this.minDelayedSendDate = nowDate.toDate();
    nowDate = moment();
    nowDate.add(3, 'months');
    this.maxDelayedSendDate = nowDate.toDate();
    this.selectedSpool = new Spool();
    this.selectedSpool.spoolId = '_NA_';
    this.selectedSpool.name = '';
    this.spoolFileValidity = false;
    this.delayedSend = false;
    this.delayedSendDate = null;
    this.initLreObject();
    this.enableCreateSpool = this.authService.getCurrentUser().admin;
    this.titleItems = [];
    this.titleItems.push({label: 'Monsieur', value: 'Monsieur'});
    this.titleItems.push({label: 'Madame ', value: 'Madame'});
    this.signerQualityItems = [];
    this.signerQualityItems.push({label: this.translateService.instant('COMMON.SIGNER.PROFESSIONAL'), value: 'PROFESSIONAL'});
    this.signerQualityItems.push({label: this.translateService.instant('COMMON.SIGNER.PERSONAL'), value: 'PERSONAL'});
    this.authTypeItems = [];
    this.authTypeItems.push({label: 'Authentification par E-mail', value: 'mailOTP'});
    this.authTypeItems.push({label: 'Authentification par SMS', value: 'smsOTP'});
    this.getTradForComponent();
    this.setModalTitle();
    this.fillTreatmentChainsAndSpools();
    this.createDepositService.customerSpoolList.subscribe(spools => {
      this.processCustomerSpool(spools);
    });
    this.verifyDefaultTreatmentChainExist();
  }
  private initLreObject(): void {
    this.lreObject = new Lre(this.authService.getCurrentUser().idCustomer);
    this.lreObject.recipient.title = 'Monsieur';
    this.lreObject.sender.title = 'Monsieur';
    this.currentRecipientAddress = {
      sElem: [],
      country: 'FRANCE',
      mElemByName: {}
    };
    this.createDepositService.getLREDefaultSender().subscribe(defaultSender => {
      if (defaultSender) {
        this.lreObject.sender.title = defaultSender.title || '';
        this.lreObject.sender.firstName = defaultSender.firstName || '';
        this.lreObject.sender.lastName = defaultSender.lastName;
        this.lreObject.sender.company = defaultSender.company;
        this.lreObject.sender.mailAddress = defaultSender.mail;
        this.lreObject.sender.phoneNumber = defaultSender.phone;
        const elementByName: any = {};
        const elements = [];
        if (defaultSender.address) {
          const foundAddress = defaultSender.address;
          if (foundAddress.RECIPIENT) {
            elements.push(foundAddress.RECIPIENT);
            elementByName.addrElem1 = foundAddress.RECIPIENT;
          }
          if (foundAddress.APARTMENT) {
            elements.push(foundAddress.APARTMENT);
            elementByName.addrElem2 = foundAddress.APARTMENT;
          }
          if (foundAddress.BUILDING) {
            elements.push(foundAddress.BUILDING);
            elementByName.addrElem3 = foundAddress.BUILDING;
          }
          if (foundAddress.STREET) {
            elements.push(foundAddress.STREET);
            elementByName.addrElem4 = foundAddress.STREET;
          }
          if (foundAddress.SERVICE) {
            elements.push(foundAddress.SERVICE);
            elementByName.addrElem5 = foundAddress.SERVICE;
          }
          if (foundAddress.POSTAL_CODE) {
            elements.push(foundAddress.POSTAL_CODE);
            elementByName.zipcode = foundAddress.POSTAL_CODE;
          }
          if (foundAddress.CITY) {
            elements.push(foundAddress.CITY);
            elementByName.city = foundAddress.CITY;
            elementByName.addrElem7 = ' ';
          }
          if (foundAddress.COUNTRY) {
            elements.push(foundAddress.COUNTRY);
            elementByName.country = foundAddress.COUNTRY;
          }
          this.lreObject.sender.address = [];
          this.lreObject.sender.address.push(elements.join('\n'));
          this.currentSenderAddress = {
            sElem: elements,
            country: foundAddress.COUNTRY ? foundAddress.COUNTRY : 'FRANCE',
            mElemByName: elementByName
          };
        }
      }
    });
  }

  /**
   * build the upload kind choice and select the correct ones if it's possible
   */
  private buildKindOfUploadChoice(): void {
    this.options = [];
    const userPermissions = this.authService.getCurrentUser().permissions;
    if (userPermissions.webDepotUnit.available) {
      this.options.push({label: this.letterLabel, value: KindOfUpload.LETTER});
    }
    if (userPermissions.webDepotMailing.available) {
      this.options.push({label: this.mailingLabel, value: KindOfUpload.MAILING});
    }
    /*if (this.enableMailing) {
      this.options.push({label: this.mailingLabel, value: KindOfUpload.MAILING});
    }*/
    if (userPermissions.webDepotSpool.available) {
      this.options.push({label: this.spoolLabel, value: KindOfUpload.SPOOL});
    }
    if (userPermissions.webDepotLRE.available) {
      this.options.push({label: this.lreLabel, value: KindOfUpload.LRE});
    }
    /*if (this.enableLre) {
      this.options.push({label: this.lreLabel, value: KindOfUpload.LRE});
    }*/
    this.btnClass = 'btn-class-' + this.options.length;
    if (!this.kindOfUpload) {
      this.selectedOption = KindOfUpload.NONE;
    } else {
      this.selectedOption = this.kindOfUpload;
    }

  }

  /**
   * fill list of treatmentChains adding default one
   */
  private fillTreatmentChainsAndSpools(): void {
    this.treatmentChains.push({
      label: this.treatmentChainService.defaultTreatmentChain,
      value: this.treatmentChainService.defaultTreatmentChain
    });
    this.userManagementService.getGroupChain(this.authService.getCurrentUser().groupId).subscribe(response => {
      const list = response || [];
      if (list && list.length > 0) {
        for (const entry of list) {
          for (const treatmentChain of this.treatmentChainService.getTreatmentChainList()) {
            if (entry === treatmentChain.sTrtChainName) {
              if (treatmentChain.sTrtChainName && treatmentChain.sTrtChainName.indexOf('LRE') === 0) {
                this.treatmentChainsLre.push({label: treatmentChain.sTrtChainName, value: treatmentChain.sTrtChainName});
              } else {
                this.treatmentChains.push({label: treatmentChain.sTrtChainName, value: treatmentChain.sTrtChainName});
              }
            }
          }
        }
      }
      else {
        for (const treatmentChain of this.treatmentChainService.getTreatmentChainList()) {
          if (treatmentChain.sTrtChainName && treatmentChain.sTrtChainName.indexOf('LRE') === 0) {
            this.treatmentChainsLre.push({label: treatmentChain.sTrtChainName, value: treatmentChain.sTrtChainName});
          } else {
            this.treatmentChains.push({label: treatmentChain.sTrtChainName, value: treatmentChain.sTrtChainName});
          }
        }
      }
    });

    this.selectedTreatmentChain = this.treatmentChainService.defaultTreatmentChain;
    if (this.treatmentChainsLre.length > 0) {
      this.selectedTreatmentChainLre = this.treatmentChainsLre[0].value;
    }

    this.kindOfAcceptedFilesService.getCustomerSpoolList().subscribe(customerSpools => {
      this.processCustomerSpool(customerSpools);
    });
  }

  processCustomerSpool(customerSpools: Spool[]) {
    this.spools = [];
    const ds = new Spool();
    ds.spoolId = '_NA_';
    ds.name = '';
    this.spools.push(ds);
    for (const spool of customerSpools) {
      this.spools.push(spool);
    }
    if (this.spools.length === 2) {
      this.selectedSpool = this.spools[1];
    } else {
      this.selectedSpool = ds;
    }
    this.spoolFileValidity = this.selectedSpool.spoolId !== '_NA_';
  }

  /**
   * Get translations for the component
   */
  private getTradForComponent(): void {
    this.translateService.get('LEFT.CONTAINER_COMPONENT.OPTION_LRE_LABEL').subscribe((label: string) => {
      this.lreLabel = label;
    });
    this.translateService.get('LEFT.CONTAINER_COMPONENT.OPTION_LETTER_LABEL').subscribe((label: string) => {
      this.letterLabel = label;
    });
    this.translateService.get('LEFT.CONTAINER_COMPONENT.OPTION_MAILING_LABEL').subscribe((label: string) => {
      this.mailingLabel = label;
    });
    this.translateService.get('LEFT.CONTAINER_COMPONENT.OPTION_SPOOL_LABEL').subscribe((label: string) => {
      this.spoolLabel = label;
    });
    this.translateService.get('APPLICATION.CONTAINER_COMPONENT.MODAL_UPLOAD_LRE_HEADER').subscribe((label: string) => {
      this.lreModalTitle = label;
    });
    this.translateService.get('APPLICATION.CONTAINER_COMPONENT.MODAL_UPLOAD_LETTER_HEADER').subscribe((label: string) => {
      this.letterModalTitle = label;
    });
    this.translateService.get('APPLICATION.CONTAINER_COMPONENT.MODAL_UPLOAD_SPOOL_HEADER').subscribe((label: string) => {
      this.spoolModalTitle = label;
    });
    this.translateService.get('APPLICATION.CONTAINER_COMPONENT.MODAL_UPLOAD_MAILING_HEADER').subscribe((label: string) => {
      this.mailingModalTitle = label;
    });
    this.translateService.get('APPLICATION.CONTAINER_COMPONENT.MODAL_UPLOAD_NOTSET_HEADER').subscribe((label: string) => {
      this.notSetModalTitle = label;
    });
    this.translateService.get('TOASTER.SUCESS_REQUEST_OK').subscribe((label: string) => {
      this.successRequestMessage = label;
    });
    this.translateService.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((label: string) => {
      this.successRequestTitle = label;
    });
    this.translateService.get('FILES.UPLOAD_COMPONENT.CONFIRMATION_MESSAGE.PERFORM_CHANGE').subscribe((label: string) => {
      this.confirmationMessage = label;
    });
    this.translateService.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((label: string) => {
      this.errorRequestTitle = label;
    });
    this.translateService.get('TOASTER.ERROR_MESSAGE_MESSAGE').subscribe((label: string) => {
      this.errorRequestMessage = label;
    });
    this.translateService.get('FILES.UPLOAD_COMPONENT.CONFIRMATION_MESSAGE.CONFIRMATION_MODAL_TITLE').subscribe((label: string) => {
      this.confirmationHeaderTitle = label;
      this.buildKindOfUploadChoice();
    });
  }

  /**
   * Set the correct modal title corresponding to the context (current upload kind)
   */
  private setModalTitle(): void {
    switch (this.selectedOption) {
      case KindOfUpload.LRE:
        this.modalTitle = this.lreModalTitle;
        break;
      case KindOfUpload.LETTER:
        this.modalTitle = this.letterModalTitle;
        break;
      case KindOfUpload.MAILING:
        this.modalTitle = this.mailingModalTitle;
        break;
      case KindOfUpload.SPOOL:
        this.modalTitle = this.spoolModalTitle;
        break;
      case KindOfUpload.NONE:
        this.modalTitle = this.notSetModalTitle;
    }
  }

  /**
   * Fire close modal event
   */
  public closeUpload(): void {
    this.modalDisplay.next(false);
  }

  /**
   * determine the correct modal title and correct behavior when switching of upload kind
   */
  public updateContext(event: any): void {
    if (this.files.length > 0) {

      this.confirmationService.confirm({
        message: this.confirmationMessage,
        header: this.confirmationHeaderTitle,
        accept: () => {
          this.selectedOption = event.value;
          this.uploadChoice.value = event.value;
          this.setModalTitle();
          this.changeDetectorRef.detectChanges();
        },
        reject: () => {

          this.uploadChoice.value = this.selectedOption;
        }
      });
    } else {
      this.selectedOption = event.value;
      this.uploadChoice.value = event.value;
      this.setModalTitle();
    }

  }

  /**
   * create index on files (reorder on back-office)
   */
  private setIndexToFiles(): void {
    let principalCount = 0;
    let annexCount = 0;
    let dataCount = 0;
    let spoolCount = 0;

    for (const file of this.files) {
      switch (file.kindOfFile) {
        case FileStatus.PRINCIPAL:
          file.index = principalCount;
          principalCount++;
          break;
        case FileStatus.ANNEXE:
          file.index = annexCount;
          annexCount++;
          break;
        case FileStatus.DATA:
          file.index = dataCount;
          dataCount++;
          break;
        case FileStatus.SPOOL:
          file.index = spoolCount;
          spoolCount++;
          break;
      }
    }
  }

  /**
   * Upload files to the server
   */
  public sendFiles(): void {
    if (this.selectedOption === KindOfUpload.LRE) {
      this.createDepositService.createLREDeposit(this.lreObject, this.selectedTreatmentChainLre, this.files).subscribe(response => {
          if (response.ok) {
            this.resetStateAfterUpload();
            this.commonService.addToast({
              life: 3000,
              severity: 'success',
              summary: this.successRequestTitle,
              detail: this.successRequestMessage
            });
            this.closeUpload();
          } else {
            this.commonService.addToast({
              life: 3000,
              severity: 'error',
              summary: this.errorRequestTitle,
              detail: this.errorRequestMessage
            });
          }
        }
      );
    } else {
      this.setIndexToFiles();
      this.createDepositService.createNewDeposit(this.selectedOption, this.selectedTreatmentChain, this.files, this.selectedSpool.spoolId, this.delayedSendDate).subscribe(response => {
          if (response.body.bOK) {
            this.resetStateAfterUpload();
            this.commonService.addToast({
              life: 3000,
              severity: 'success',
              summary: this.successRequestTitle,
              detail: this.successRequestMessage
            });
            this.closeUpload();
          } else {
            this.commonService.addToast({
              life: 3000,
              severity: 'error',
              summary: this.errorRequestTitle,
              detail: this.errorRequestMessage
            });
          }
        }
      );
    }
  }

  /**
   * reset component to original state
   */
  private resetStateAfterUpload(): void {
    this.files = [];
    this.shouldClearFiles.next(true);
    this.initLreObject();
  }

  /**
   * handle event from change on childComponent (file-upload)
   * @param {string} kindOfFile - check KindOfFile pseudo-enum for more information
   * @param {boolean} validtyFromChild - if the child upload is valid
   */
  public updateUploadValidity(kindOfFile: string, validtyFromChild: boolean) {
    switch (kindOfFile) {
      case FileStatus.PRINCIPAL:
        this.principalFileValidity = validtyFromChild;
        break;
      case FileStatus.ANNEXE:
        this.annexeFileValidity = validtyFromChild;
        break;
      case FileStatus.DATA:
        this.dataFileValidity = validtyFromChild;
        break;
      /*      case FileStatus.SPOOL:
              this.spoolFileValidity = validtyFromChild;
              break;*/
    }
  }

  /**
   * Update list of files
   * @param {string} kindOfFile - check KindOfFile pseudo-enum for more information
   * @param  files - list of files from the child component
   */
  public updateFilesWithStatus(kindOfFile: string, files: any) {
    this.files = this.files.filter(x => x.kindOfFile !== kindOfFile);
    for (const file of files) {
      this.files.push({kindOfFile: kindOfFile, file: file});
    }
  }

  /**
   *  Determine the impact of the change for upload validity (from template)
   */
  public uploadIsPossible(): boolean {
    switch (this.selectedOption) {
      case KindOfUpload.LRE:
        return this.principalFileValidity && this.isValidLreObject();
      case KindOfUpload.LETTER:
        return this.principalFileValidity && this.annexeFileValidity && (!this.delayedSend || (this.delayedSend && this.delayedSendDate !== null)) && ((this.selectedTreatmentChain == this.treatmentChainService.defaultTreatmentChain && this.bDefaultTreatmentChainExist)||(this.selectedTreatmentChain != this.treatmentChainService.defaultTreatmentChain));

      case KindOfUpload.MAILING:
        return this.principalFileValidity && this.annexeFileValidity && this.dataFileValidity && ((this.selectedTreatmentChain == this.treatmentChainService.defaultTreatmentChain && this.bDefaultTreatmentChainExist)||(this.selectedTreatmentChain != this.treatmentChainService.defaultTreatmentChain));

      case KindOfUpload.SPOOL:
        return this.principalFileValidity && this.annexeFileValidity && this.spoolFileValidity && ((this.selectedTreatmentChain == this.treatmentChainService.defaultTreatmentChain && this.bDefaultTreatmentChainExist)||(this.selectedTreatmentChain != this.treatmentChainService.defaultTreatmentChain));

      case KindOfUpload.NONE:
        return false;
      default:
        return false;
    }
  }

  /**
   * function that handle retrieving the list of accepted files per fileStatus
   *
   * @param {string} fileStatus - kind of file (Annex, Principal (...))
   * @return {string[]} - list of accepted extensions
   */
  public gestListOfAcceptedFiles(fileStatus: string): string[] {

    switch (fileStatus) {
      case FileStatus.PRINCIPAL:
        return this.kindOfAcceptedFilesService.PRINCIPAL_FILE_EXTENSIONS;
      case FileStatus.ANNEXE:
        return this.kindOfAcceptedFilesService.ANNEX_FILE_EXTENSIONS;
      case FileStatus.DATA:
        return this.kindOfAcceptedFilesService.DATA_FILE_EXTENSIONS;
      case FileStatus.SPOOL:
        return this.kindOfAcceptedFilesService.SPOOL_FILE_EXTENSIONS;
      default:
        return this.kindOfAcceptedFilesService.PRINCIPAL_FILE_EXTENSIONS;
    }
  }

  public showLreDetectedProblems(): boolean {
    return !this.principalFileValidity
      || (this.selectedOption !== KindOfUpload.LRE && !this.annexeFileValidity)
      || (this.selectedOption === KindOfUpload.MAILING && !this.dataFileValidity)
      || (this.selectedOption === KindOfUpload.SPOOL && this.spoolFileValidity)
      || (this.selectedOption === KindOfUpload.LRE && !this.lreObject.isValid());
  }

  public isValidLreObject() {
    return this.lreObject.isValid();
  }

  public getValidationErrors() {
    return this.lreObject.getValidationErrors();
  }

  public isValidMail(mail: string): boolean {
    return EmailValidator.emailIsValid(mail);
  }

  public isValidAddress(address: string[]): boolean {
    return address && address.length > 0 && address[0].split('\n').length >= 2;
  }

  public selectSpool(): void {
    setTimeout(() => {
      this.spoolFileValidity = this.selectedSpool.spoolId !== '_NA_';
    }, 100);
  }

  public showCreateSpoolDialog(): void {
    this.showCreateSpool = true;
  }

  public hideCreateSpoolDialog(): void {
    this.showCreateSpool = false;
  }

  deleteSpool(): void {
    this.createDepositService.deleteSpool(this.selectedSpool.spoolId).subscribe(response => {
        if (response.body.bOK) {
          this.commonService.addToast({
            life: 3000,
            severity: 'success',
            summary: this.successRequestTitle,
            detail: this.successRequestMessage
          });
        } else {
          this.commonService.addToast({
            life: 3000,
            severity: 'error',
            summary: this.errorRequestTitle,
            detail: this.errorRequestMessage
          });
        }
      }
    );
  }

  public showRecipientAddress() {
    this.openRecipientAddress = true;
  }

  public showSenderAddress() {
    this.openSenderAddress = true;
  }

  public handleRecipientAddress(address: any): void {
    this.currentRecipientAddress = {
      sElem: address.fa,
      mElemByName: this.addressLinesToMap(address.lines)
    };
    this.lreObject.recipient.address = [];
    this.lreObject.recipient.address.push(address.fa.join('\n'));
  }

  public handleSenderAddress(address: any): void {
    this.currentSenderAddress = {
      sElem: address.fa,
      mElemByName: this.addressLinesToMap(address.lines)
    };
    this.lreObject.sender.address = [];
    this.lreObject.sender.address.push(address.fa.join('\n'));
  }

  public handleRecipientAddressClose(result: boolean): void {
    this.openRecipientAddress = result;
  }

  public handleSenderAddressClose(result: boolean): void {
    this.openSenderAddress = result;
  }

  public addressLinesToMap(lines: AddressLine[]): any {
    const map: any = {};
    for (const line of lines) {
      map[line.sDataName] = line.sDataValue;
    }
    return map;
  }

  public clearDelayedDate(): void {
    if (!this.delayedSend) {
      this.delayedSendDate = null;
    }
  }

  public verifyDefaultTreatmentChainExist(): void {
    this.createDepositService.verifyDefaultTreatmentChainExist().subscribe(response => {
      if (response != null){
        this.bDefaultTreatmentChainExist = response
      }
    });
  }

}
